import "./ExploreMenu.css";
import { menu_list } from "../../assets/assets";

const ExploreMenu = ({ category, setCategory }) => {
  return (
    <div className='explore-menu' id='explore-menu'>
      <h1>Discover our menu</h1>
      <p className='explore-menu-text'>
        Embark on a culinary journey at FoodZing. Explore our menu for
        tantalizing flavors and exquisite dishes crafted by our talented chefs.
      </p>
      <div className='explore-menu-list'>
        {menu_list.map((item) => {
          return (
            <div
              onClick={() =>
                setCategory((prev) =>
                  prev === item.menu_name ? "All" : item.menu_name
                )
              }
              key={item.menu_name}
              className='explore-menu-list-item'>
              <img
                className={category === item.menu_name ? "active" : ""}
                src={item.menu_image}
                alt={item.menu_name}
              />
              <p>{item.menu_name}</p>
            </div>
          );
        })}
      </div>
      <hr />
    </div>
  );
};

export default ExploreMenu;
